<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row>
                  <b-col lg="10" md="10">
                    <h5 class="mt-2" v-text="Title"></h5>
                  </b-col>

                  <b-col lg="2" md="2" class="pl-1">
                    <b-button
                      variant="primary"
                      block
                      @click="$router.push('/customer-list')"
                      id="all-customers-btn"
                      >All Customers</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="card mt-2">
            <div
              class="customer-info box-shadow p-3"
              style="height:calc(100vh - 70px)"
            >
              <b-container fluid>
                <customer-dashboard
                  :custDetails="customerDetails"
                  :type="'profile'"
                  @get-profile="getCustomerDetails"
                />
              </b-container>
            </div>
            <div class="clearfix"></div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import CustomerDashboard from "../components/CustomerDashboard";

export default {
  name: "customer-details",
  props: ["mobile"],
  components: {
    Dashboard,
    Loading,
    CustomerDashboard,
  },
  mounted() {
    this.getCustomerDetails();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },

  data() {
    return {
      Title: "Customer Profile",
      loading: true,
      customerDetails: { data: "", address: "", summary: "" },
    };
  },
  methods: {
    getCustomerDetails() {
      this.$loading = true;
      let data = {
        api_token: this.state.sessions.user.api_token,
        trans_from: this.state.system.trans_from,
        mobile: this.mobile,
        vu_id: this.state.sessions.user.vu_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        url: "/get-profile",
      };

      axios
        .post(data.url, data)
        .then((response) => {
          this.customerDetails = response.data;
          delete this.customerDetails.status;
          delete this.customerDetails.message;
          if (this.customerDetails.address == null) {
            this.customerDetails.address = {
              address1: "",
              address2: "",
              landmark: "",
              pincode: "",
              city_name: "",
              state_name: "",
              city_id: "",
              state_id: "",
            };
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
  },
};
</script>
<style></style>
